import { Observable } from 'rxjs';

import {
	IUserModuleSuggestion,
	UserModuleSuggestion,
} from 'user/suggestion/user-module-suggestion';

export abstract class UserModuleSuggestionRepositoryPort {
	public abstract observeUserModuleSuggestions(
		userId: string
	): Observable<IUserModuleSuggestion[]>;

	public abstract replaceUserModuleSuggestions(
		userId: string,
		entities: UserModuleSuggestion[]
	): void;
}
